import React from "react"
import Parse from "html-react-parser"

class LayoutOne extends React.Component {
    constructor() {
        super();
        this.state = {
            products: []
        }
    }

    componentDidMount() {
        // this.setState({products: this.props.products})
    }

    render() {
        let {chooseProduct, currency, products} = this.props;
        return (
            <div className="box-colum">
                <div className="box-contants">
                    {/*<div className="price-icon">

                    </div>*/}
                    <h4 className="title titleBorder"><img src={'/images/search.png'} style={{width: 34}}/> <a> PRICE
                        LIST</a></h4>

                    <div className="product-add">
                        <div className={'row'}>
                            {products && products.length ? products.map((item, key) => {
                                return (
                                    <div className={'col-md-6 col-sm-12'} key={key}>
                                        <span>&nbsp;</span>
                                        <div className="box-contant-left"><p>{item.name}</p></div>
                                        <div className="box-contant-right"><p
                                            onClick={() => {
                                                chooseProduct({...item, layout: 'Layout2'});
                                                window.okfunction()
                                            }}>
                                            <strong>{currency} {item.price.toFixed(2)} </strong>
                                            <i className="fa fa-plus"
                                               aria-hidden="true"></i>
                                        </p>
                                        </div>
                                    </div>
                                )

                            }) : ''}
                        </div>
                    </div>


                </div>
            </div>
        )
    }
}

export default LayoutOne;
